<!-- Add Parts to Quote popup -->
<p-dialog
  [dismissableMask]="true"
  [(visible)]="showSendEmailPopUp"
  (onHide)="onHide()"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
  [styleClass]="'email-popup'"
  (click)="closeModalOutside($event)"
  [closable]="false"
>
  <ng-template pTemplate="content">
    <div
      class="container-send-email-popup content-dialog"
      (click)="$event.stopPropagation()"
    >
      <div class="header">
        <h2>Send Email</h2>
        <div class="close-popup" (click)="closeModalOutside($event)">
          <img src="./assets/images/ic-close.svg" alt="ic-close" />
        </div>
      </div>
      <form
        [formGroup]="sendMailForm"
        #form="ngForm"
        (ngSubmit)="save()"
        novalidate
      >
        <div class="form-group full-width">
          <label for="" class="form-label">Receiver(s)</label>
          <p-multiSelect
            formControlName="receivers"
            placeholder="Select Receiver Email"
            [options]="receiversArray"
            optionLabel="email"
          >
          </p-multiSelect>
          <app-form-errors
            [color]="'danger'"
            [form]="form"
            [control]="sendMailForm.controls['receivers']"
          >
          </app-form-errors>
        </div>
        <div class="form-group full-width">
          <label for="" class="form-label">CC To</label>
          <p-autoComplete
            [delay]="500"
            formControlName="cc"
            placeholder="Select CC Emails"
            [suggestions]="suggestions"
            (completeMethod)="onQueryChange($event)"
            (onSelect)="onSelected($event)"
            field="email"
            [multiple]="true"
          >
          </p-autoComplete>
          <div
            *ngIf="sendMailForm.controls['validationErrCC'].value"
            class="general-err"
          >
            {{ sendMailForm.controls["validationErrCC"].value }}
          </div>
        </div>

        <div class="form-group">
          <label for="" class="form-label">Delivery Acknowledgment</label>
          <p-dropdown
            [ngClass]="'delivery'"
            formControlName="delivery_acknowledge"
            placeholder="Select Yes/No"
            [options]="delivery"
            optionLabel="name"
            [showClear]="true"
          ></p-dropdown>
          <app-form-errors
            [color]="'danger'"
            [form]="form"
            [control]="sendMailForm.controls['delivery_acknowledge']"
          >
          </app-form-errors>
        </div>

        <div class="form-group">
          <label for="" class="form-label">Email Subject</label>
          <input type="text" formControlName="subject" class="form-control" />
          <app-form-errors
            [color]="'danger'"
            [form]="form"
            [control]="sendMailForm.controls['subject']"
          >
          </app-form-errors>
        </div>

        <div class="uploaded-files">
          <div class="list-file">
            <div class="title">Attached Files</div>
            <div *ngIf="isUploaded" class="files">
              <div class="file-info">
                <div class="file-name">{{ fileName }}</div>
                <!-- <div class="hide-show-file"><img src="./assets/images/eye.svg" alt="eye"></div> -->
                <div
                  class="remove-file"
                  (click)="deleteFile()"
                  style="cursor: pointer"
                >
                  <img src="./assets/images/trash2-fill.svg" alt="" />
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!isUploaded" class="form-upload">
            <div class="placeholder-files">
              <div class="icon">
                <img
                  src="./assets/images/contracts/icon-plus.svg"
                  alt="icon-plus"
                />
              </div>
              <span>Choose File To Upload</span>
            </div>
            <input
              type="file"
              [allowedExt]="photoAllowedExt"
              [size]="fileSize"
              #attachedFile
              [accept]="photoAllowedExt"
              (change)="uploadImage($event)"
              formControlName="attachFile"
              [hidden]="true"
            />
            <div class="show-upload-field" (click)="fetchFile()">
              <div class="icon">
                <app-icon name="plus" [size]="14" [strokeWidth]="2.4"></app-icon>
              </div>
              <span>Upload</span>
            </div>
          </div>
          <app-form-errors
            [color]="'danger'"
            [form]="form"
            [control]="sendMailForm.controls['attachFile']"
          >
          </app-form-errors>
        </div>

        <div class="message-container">
          <div class="title">Message</div>
          <p-editor formControlName="body" [style]="{ height: '320px' }">
            <ng-template pTemplate="header">
              <span class="ql-formats">
                <select class="ql-size">
                  <option value="small"></option>
                  <!-- Note a missing, thus falsy value, is used to reset to default -->
                  <option selected></option>
                  <option value="large"></option>
                  <option value="huge"></option>
                </select>
                <button
                  type="button"
                  class="ql-bold"
                  aria-label="Bold"
                ></button>
                <button
                  type="button"
                  class="ql-italic"
                  aria-label="Italic"
                ></button>
                <button
                  type="button"
                  class="ql-underline"
                  aria-label="Underline"
                ></button>
              </span>
            </ng-template>
          </p-editor>
          <app-form-errors
            [color]="'danger'"
            [form]="form"
            [control]="sendMailForm.controls['body']"
          >
          </app-form-errors>
        </div>

        <div class="footer-form">
          <button
            [disabled]="loadingSubmit"
            type="button"
            type="button"
            class="cancel-btn"
            (click)="closeModalOutside($event)"
          >
            Cancel
          </button>
          <button [disabled]="loadingSubmit" class="create-btn" type="submit">
            Send Email
            <i *ngIf="loadingSubmit" class="fa-spin fas fa-spinner ms-2"></i>
          </button>
        </div>
      </form>
    </div>
  </ng-template>
</p-dialog>

<!-- confirmation message -->
<app-confirmation-msg
  class="conformation"
  #messageComponent
  [isLoading]="loadingConfirm"
  (accepted)="accepted()"
  (rejected)="rejected()"
  [headerMessage]="'Confirmation Message'"
  [bodyMessage]="'Are you sure you want to discard your data?'"
>
</app-confirmation-msg>
